import { inject, Injectable } from '@angular/core'

import { BudgetLinesService } from '@app/generated/api/budget-lines/budget-lines.service'
import type { BudgetLinesListParams } from '@app/generated/api/model'

@Injectable({
  providedIn: 'root',
})
export class BudgetLinesApi {
  private readonly budgetLinesService = inject(BudgetLinesService)

  list (params: any) {
    return this.budgetLinesService.list(params as BudgetLinesListParams)
  }
}
